import React from 'react';
import PropTypes from 'prop-types';
import { TranscriptsList } from '@layout/AttendeeDashboard';
import { TranscriptCard } from './TranscriptCard';

export const AttendeeDashboard = ({ list, isCloudSearchResults }) => (
  <TranscriptsList>
    {list.map((transcript) => (
      <TranscriptCard
        key={transcript.id}
        {...transcript}
        isCloudSearchResults={isCloudSearchResults}
      />
    ))}
  </TranscriptsList>
);

AttendeeDashboard.propTypes = {
  list: PropTypes.array,
};

AttendeeDashboard.defaultProps = {
  list: [],
};



// WEBPACK FOOTER //
// ./components/organisms/AttendeeDashboard/AttendeeDashboard.js